export function _i18n_str(str: string) {
  return str;
}

// Generic UI text



// WEBPACK FOOTER //
// ./src/assets/i18n/non-static-ids.ts